import React, { useEffect } from "react"

import { graphql } from "gatsby"
import { ArticleImageTextOverlayFieldsFragment } from "../../../../../../graphql-types"

import * as styles from "./image-text-overlay.module.scss"
import { elementOffset, transformItem } from "../../../functions/functions"

type ArticleImageTextOverlayProps = {
  data: ArticleImageTextOverlayFieldsFragment
}

const ArticleImageTextOverlay: React.FC<ArticleImageTextOverlayProps> = ({ data }) => {
  const handleScrollAnimation = () => {
    document.addEventListener("scroll", () => {
      const container = document.getElementsByClassName(styles.container)

      Array.from(container).forEach(artContainer => {
        if (window.scrollY >= elementOffset(artContainer).top - 700) {
          transformItem(artContainer.getElementsByClassName(styles.transformContainer)[0], 400)
        }
      })
    })
  }

  useEffect(() => {
    handleScrollAnimation()
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.transformContainer}>
        <img src={data.image.url} alt={data.image.alt || ""} title={data.image.title} className={styles.image} />
        <h2 className={styles.textOverlay}>
          <span 
            className={styles.overlayText}
            style={{
              color: data.textColor?.hex ?? "white",
              backgroundColor: data.backgroundColor?.hex ?? "transparent",
            }}
          >
            {data.textOverlay}
          </span>
        </h2>
      </div>
    </div>
  )
}

export const fragment = graphql`
  fragment ArticleImageTextOverlayFields on DatoCmsArticleImageTextOverlay {
    __typename
    id
    image {
      alt
      format
      title
      url
    }
    textOverlay
    backgroundColor {
      hex
    }
    textColor {
      hex
    }
  }
`

export default ArticleImageTextOverlay
